import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class FavouriteService {
  static getFavouritesMatches(payload) {
    !payload.search && delete payload.search;
    return axiosClient
      .get("/sb/getFavoriteEvents", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static addOrRemoveFavourites(payload) {
    return axiosClient
      .get("/sb/addToFavorite", {
        params: { ...payload }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
